import dayjs from 'dayjs'
import { ALERT_STATUS_COLORS, ALERT_STATUS_LABELS } from '../constants'

export const formatDate = (dateString?: string | Date): string => {
  if (!dateString) {
    return ''
  }
  return dayjs(dateString).format('DD-MM-YYYY')
}

export const formatDateTime = (dateString?: string | Date): string => {
  if (!dateString) {
    return ''
  }
  return dayjs(dateString).format('DD-MM-YYYY HH:mm')
}

export const getStatusLabel = (status?: string): string => {
  if (!status) {
    return ''
  }
  return ALERT_STATUS_LABELS[status] ?? status
}

export const getStatusTagColor = (status?: string): string => {
  if (!status) {
    return 'default'
  }
  return ALERT_STATUS_COLORS[status] ?? 'default'
}
